import React, { useEffect } from 'react';
import { AccessOptionProps } from '../../types';

const Empty: React.FC<AccessOptionProps> = ({ setIsValid }) => {
  useEffect(() => {
    // always valid
    setIsValid(true);
  }, [setIsValid]);

  return null;
};

export default Empty;
